import { GET_MEMBER_DOCUMENT_QUERY } from '../../../graphql/queries/graphql-queries.constant';
import {
    GelLink,
    GelLabel
} from "@tal-gel/components";
import { SaveFile } from '../../../common/file.utils';
import MmcGraphQL from '../../../common/api/mmc-graphql';

const DocumentDownload = (props) => {

    const handleDownload = () => {
        MmcGraphQL<{content: any}>(GET_MEMBER_DOCUMENT_QUERY,
            {
                documentIdentifier: props.documentIdentifier,
                fileName: props.displayName
            }).then(async ({content}) => {
                SaveFile(content, props.displayName);
            })
            .catch((error) => {
                console.log(error)
            })
    };

    return (
        <>
            {props.documentIdentifier &&
                <GelLink onClick={() => handleDownload()}>
                    {props.displayName}
                </GelLink>}

            {!props.documentIdentifier &&
                <GelLabel style={{ fontWeight: 500 }}>
                    {props.displayName}
                </GelLabel>}
        </>
    );
};

export default DocumentDownload;